// Базовые секции
const BASE_WHY_PERFECT = {
    title: 'Видеопоздравление от ИИ-звезды',
    titleHighlight: 'идеально подходит,',
    reasons: [
        'Хочешь оригинально поздравить, но не знаешь как?',
        'Живые звезды стоят очень дорого и не отвечают в ЛС?',
        'У тебя мало времени, нужно срочно поздравить и произвести вау-эффект?'
    ]
};

const BASE_FIVE_REASONS = [
    {title: 'Эмоции бесценны', text: 'А видео с озвучкой стоит всего 1290 руб.'},
    {title: 'Время не ждет', text: 'Получи готовое видео за 5 минут'},
    {title: 'Вау-эффект', text: 'Ваше видео будут пересылать друзьям'},
    {title: 'Звезды с неба падают', text: 'Выбери звезду на свой вкус от Путина до Маска'},
    {title: '100% гарантия возврата', text: 'Вернем деньги, если ИИ-звезда начудит...'}
];

// Музыкальные конфиги
export const MUSIC_HERO = {
    title: 'Создай уникальную песню',
    titleHighlight: 'с помощью нейросети',
    features: ['от 445 руб. за песню', 'готовая песня за 3 минуты']
};

export const MUSIC_WHY_PERFECT = {
    title: 'Персональная песня от нейросети',
    titleHighlight: 'идеально подходит,',
    ctaText: 'Создать песню',
    reasons: [
        'Хочешь подарить уникальную песню, но не умеешь петь?',
        'Заказать песню у музыкантов дорого и долго?',
        'Нужен оригинальный подарок, который запомнится навсегда?'
    ]
};

export const MUSIC_FIVE_REASONS = [
    {title: 'Эмоции бесценны', text: 'А песня стоит всего 445 руб.'},
    {title: 'Время не ждёт', text: 'Получи готовую песню за 5 минут'},
    {title: 'Вау-эффект', text: 'Вашу песню будут переслушивать снова и снова'},
    {title: 'Любой стиль', text: 'Поп, рок, хип-хоп, баллада, джаз и не только'},
    {title: '100% гарантия возврата', text: 'Вернём деньги, если песня не понравится'},
];

export const MUSIC_STAR_REVIEW = 'Я попробовал этот сервис и был поражён! Нейросеть создала песню  за считанные минуты. Качество звучания на высоте, текст точно попал в настроение праздника. Теперь рекомендую всем друзьям — это лучший музыкальный подарок!';

// Сказки configs
export const SKAZKI_STAR_REVIEW = 'Собрали сказку за полминуты, пока сын чистил зубы. Он слушал без движения и попросил ещё. Утром первое, что сказал: «Мам, а можно ту сказку, где я нашёл лунную дорогу?» Теперь это наш вечерний ритуал.';

const BASE_OCCASIONS = [
    {id: 'birthday', name: 'День рождения', icon: '🎂'},
    {id: 'jubilee', name: 'Юбилей', icon: '🎊'},
    {id: 'wedding', name: 'Свадьба', icon: '💍'},
    {id: 'promotion', name: 'Повышение', icon: '🚀'},
    {id: 'graduation', name: 'Выпускной', icon: '🎓'},
    {id: 'retirement', name: 'Выход на пенсию', icon: '🏖️'},
    {id: 'anniversary', name: 'Годовщина', icon: '💑'},
    {id: 'custom', name: 'Своё', icon: '💬'}
];

// Конфиг главной страницы
const HOME_CONFIG = {
    title: 'Видеопоздравление от ИИ-звезды',
    description: 'Получи видеопоздравление от ИИ-звезды за 3 минуты',
    hero: {
        title: 'Получи видеопоздравление',
        titleHighlight: 'от ИИ-звезды',
        features: ['от 1290 руб. вместе с озвучкой', 'готовое поздравление за 3 минуты']
    },
    occasions: BASE_OCCASIONS,
    whyPerfect: BASE_WHY_PERFECT,
    fiveReasons: BASE_FIVE_REASONS,
};

export function getPageConfig() {
    return HOME_CONFIG;
}
